import { LearningObjective } from "./learning-objective.model";
import { TraditionalTrail } from "./trail.model";

export class Chapter {
  constructor(
    public id: string = "",
    public name: string = "",
    public description: string = "",
    public predecessorId: string = "",
    public chapter?: string,
    public course?: string,
    public trails?: any[],
    public learningObjectives?: LearningObjective[],
    public startDate?: any
  ) {}
}

export class TraditionalChapter {
  constructor(
    public id: string = "",
    public name: string = "",
    public description: string = "",
    public trails: TraditionalTrail[] = [],
    public learningObjectiveIdForQuiz: string = "",
    public startDate: any = "",
    public done?: boolean,
    public opened: boolean = false,
    public unlocked: boolean = false,
  ) {}
}
